// Tips de mode de vie / hygiène / sport
export const TIPS: string[] = [
  "Bois 500 ml d'eau dès le réveil avant tout autre liquide. Tu te réveilles déshydraté.",
  "Crème solaire SPF 30+ tous les matins, hiver comme été. Le visage ne ment jamais.",
  "Étire-toi 5 min avant de te coucher : meilleur sommeil, meilleure récup.",
  "Mange une source de protéines à chaque repas. Sans exception.",
  "Sieste de 20 min max. Au-delà, tu ralentis pour la journée.",
  "Coupe les écrans 45 min avant de dormir. Lecture ou musique calme à la place.",
  "Une douche froide 30 sec en fin de douche : circulation, peau, vigilance.",
  "Marche 10 min après le repas du midi. Glycémie stable, digestion fluide.",
  "Vise 1.8 à 2.2 g de protéines / kg de poids corporel par jour. Non négociable pour la prise de masse sèche.",
  "Trois exercices composés bien faits valent mieux que dix isolations bâclées.",
  "Repos = croissance. Le muscle se construit au sommeil, pas à la séance.",
  "Tiens un cap : même séance courte vaut mieux qu'aucune séance.",
  "Range ta chambre avant de te coucher. Tu te réveilles dans un esprit clair.",
  "Magnésium le soir : sommeil, récup musculaire, gestion du stress.",
  "En boxe, la technique avant la puissance. Toujours.",
  "Note tes charges après chaque séance. Sans suivi, pas de progression.",
  "Hydrate-toi pendant la séance : 500 ml pour 1h d'effort.",
  "Mange une portion de légumes verts tous les jours. Foie, peau, micronutriments.",
  "Évite l'alcool en semaine. Sommeil détruit, récup en chute libre.",
  "Soigne ton entrée et ta sortie de séance : 5 min de mobilité, ça change tout.",
];
